<template>
  <div class="detail_box">
    <van-swipe v-if="!!galleryInfo" :show-indicators="false" :loop="false" @change="onChange">
      <van-swipe-item v-for="(item, index) in galleryInfo.pictureList" :key="index">
        <div class="img" :style="{
            backgroundImage:
              'url(' +
              (item.imagePath == ''
                ? require('@/assets/images/user_default.png')
                : item.imagePath) +
              ')',
          }" @click="handleShowInfo"></div>
      </van-swipe-item>
    </van-swipe>
    <div class="desc_box clearfix" v-if="showDesc">
      <div class="title">
        <span class="num" v-text="curInfo.curIndex"></span>
        <span v-text="curInfo.title"></span>
      </div>
      <div class="desc" v-text="curInfo.desc"></div>
    </div>
  </div>
</template>
<script>
import { deepClone } from "@/utils";
export default {
  name: "Detail",
  props: {
    detail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      galleryInfo: null,
      showDesc: true, //是否显示描述
      /* 当前显示图片的相关信息 */
      curInfo: {
        title: "",
        curIndex: "",
        desc: "",
      },
    };
  },
  watch: {
    detail: {
      handler(newValue, oldValue) {
        this.galleryInfo = deepClone(newValue);
        if (this.galleryInfo.pictureList.length > 0) {
          this.curInfo.title = this.galleryInfo.title;
          this.curInfo.desc = this.galleryInfo.pictureList[0].desc;
          this.curInfo.curIndex =
            1 + "/" + this.galleryInfo.pictureList.length;
        } else {
          this.curInfo.title = this.galleryInfo.title;
          this.curInfo.curIndex = "";
        }
      },
      deep: true,
    },
  },
  methods: {
    /* 切换时触发，更新描述信息 */
    onChange(index) {
      this.curInfo.title = this.galleryInfo.title;
      this.curInfo.curIndex =
        index + 1 + "/" + this.galleryInfo.pictureList.length;
      this.curInfo.desc = this.galleryInfo.pictureList[index].desc;
    },
    /* 显示/隐藏描述 */
    handleShowInfo() {
      this.showDesc = !this.showDesc;
    },
  },
  created() {
    this.galleryInfo = deepClone(this.detail);
    if (this.galleryInfo.pictureList.length > 0) {
      this.curInfo.title = this.galleryInfo.title;
      this.curInfo.curIndex = 1 + "/" + this.galleryInfo.pictureList.length;
      this.curInfo.desc = this.galleryInfo.pictureList[0].desc;
    } else {
      this.curInfo.title = this.galleryInfo.title;
      this.curInfo.curIndex = "";
    }

  },
};
</script>
<style scoped lang="scss">
.detail_box {
  width: 100%;
  height: 100%;
  .van-swipe {
    width: 100%;
    height: 100%;
    .van-swipe-item {
      .img {
        width: 100%;
        // height: 100%;
        height: calc(100vh - 52px);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
  }
  .desc_box {
    position: absolute;
    bottom: 40px;
    z-index: 1;
    width: 100%;
    padding: 10px 15px;
    background: rgba(0, 0, 0, 0.7);
    overflow: auto;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    .title {
      .num{
        margin-right: 10px;
      }
      margin-bottom: 5px;
      color: #fff;
      font-size: 18px;
    }
    .desc {
      line-height: 22px;
      color: #aaa;
      font-size: 16px;
    }
  }
}
</style>